import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth/AuthContext";
import axios from "axios";
import Swal from "sweetalert2";
import mark1 from "../assets/img/users.png";

function Profile() {
  const { profile, token, setProfile } = useContext(AuthContext);
  const baseURL = process.env.REACT_APP_API_URL;

  const [form, setForm] = useState({
    username: "",
    fullname: "",
    email: "",
    mobile_no: "",
  });

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(mark1);
  const [localPreviewUrl, setLocalPreviewUrl] = useState(null);

  useEffect(() => {
    if (!profile) return;

    setForm({
      username: profile.username || "",
      fullname: profile.fullname || "",
      email: profile.email || "",
      mobile_no: profile.mobile_no || "",
    });

    // ✅ agar local file select nahi hai tab server wali image show karo
    if (!file) {
      setPreview(
        profile.profile_pic
          ? `${baseURL}/uploads/${profile.profile_pic}?t=${Date.now()}`
          : mark1
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, baseURL]);

  useEffect(() => {
    return () => {
      if (localPreviewUrl) URL.revokeObjectURL(localPreviewUrl);
    };
  }, [localPreviewUrl]);

  const handlePickFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;

    if (!f.type.startsWith("image/")) {
      Swal.fire("Error", "Only image files allowed", "error");
      return;
    }

    if (localPreviewUrl) URL.revokeObjectURL(localPreviewUrl);

    const url = URL.createObjectURL(f);
    setLocalPreviewUrl(url);
    setPreview(url); // ✅ INSTANT preview
    setFile(f);
  };

  const handleUpdate = async () => {
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v || ""));
      if (file) fd.append("profile_pic", file);

      const res = await axios.put(`${baseURL}/dashboard/profile-update`, fd, {
        headers: {
          "x-access-token": token,
          "Content-Type": "multipart/form-data",
        },
      });

      setProfile(res.data.result);
      setFile(null);

      if (localPreviewUrl) URL.revokeObjectURL(localPreviewUrl);
      setLocalPreviewUrl(null);

      Swal.fire("Success", "Profile updated", "success");
    } catch (e) {
      Swal.fire("Error", e.response?.data?.message || "Update failed", "error");
    }
  };

  if (!profile) return null;

  return (
    <div className="container mt-4">
      <div className="card shadow p-4 rounded-4">
        <div className="d-flex gap-3 mb-3 align-items-center">
          <img
            src={preview}
            alt="Profile"
            style={{
              width: 90,
              height: 90,
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid rgba(187,17,20,0.25)",
            }}
          />

          <label className="btn btn-outline-secondary btn-sm">
            Change Photo
            <input type="file" hidden accept="image/*" onChange={handlePickFile} />
          </label>
        </div>

        {["username", "fullname", "email", "mobile_no"].map((f) => (
          <div className="mb-3" key={f}>
            <label className="text-capitalize text-dark">
              {f.replace("_", " ")}
            </label>
            <input
              className="form-control"
              value={form[f]}
              onChange={(e) => setForm({ ...form, [f]: e.target.value })}
            />
          </div>
        ))}

        <button className="btn btn-success" onClick={handleUpdate}>
          Update Profile
        </button>
      </div>
    </div>
  );
}

export default Profile;
